// extracted by mini-css-extract-plugin
export var cardLayout = "_af-1";
export var paginationContainer = "_af-0";